import React, { useState } from "react"
import { Table } from "react-bootstrap"
import { BsSortDown } from "react-icons/bs"
import { useSelector } from "react-redux"
import { selectAccounts } from "../../../../redux/account/account.selectors"
import SpinnerComponent from "../../../../components/commons/SpinnerComponent"
import EditMessageTemplate from "./EditMessageTemplate"
import Icon from "../../../../components/commons/Icon"
import { FaEdit, FaTrash } from "react-icons/fa"
import DeleteMessageTemplate from "./DeleteMessageTemplate"

const MessageTemplatesTabel = () => {
  const account = useSelector(selectAccounts)

  if (!account) {
    return <SpinnerComponent />
  }

  return (
    <Table className="mt-3" hover>
      <thead>
        <tr style={{ height: "50px", borderBottom: "2px solid #dee2e6" }}>
          <th style={{ width: "20px" }}>#</th>
          <th className="align-middle">Template name</th>
          <th className="align-middle">Template message</th>

          <th></th>
        </tr>
      </thead>
      <tbody>
        {account?.right_request_templates?.textMessages?.map(
          (message, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td className="align-middle">{message.templateName}</td>
              <td
                className="align-middle text-truncate"
                style={{ maxWidth: "300px" }}
              >
                {message.textMessage}
              </td>
              <td className="d-flex flex-row justify-content-end">
                <EditMessageTemplate
                  existingTemplate={message}
                  existingIndex={index}
                  btn={
                    <Icon tooltip="Edit template">
                      <FaEdit />
                    </Icon>
                  }
                />
                <DeleteMessageTemplate
                  existingTemplate={message}
                  existingIndex={index}
                  btn={
                    <Icon tooltip="Delete template">
                      <FaTrash />
                    </Icon>
                  }
                />
              </td>
            </tr>
          )
        )}
      </tbody>
    </Table>
  )
}

export default MessageTemplatesTabel
